import { Button, Flex, Stepper, TextField } from '@servicetitan/anvil2';
import { ConsentDataStore, SignatureDataStore } from '@servicetitan/financing-decision-shared';
import { signatureForm } from './LoanAgreement.module.scss';
import { useSignatureValidator } from './useSignatureValidator';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';

export interface SignaturesFooter {
    hasCoApplicant?: boolean;
}

export const SignaturesFooter = ({ hasCoApplicant }: SignaturesFooter) => {
    const { signatureData, setSignatureData } = SignatureDataStore.useStore();
    const { consentData } = ConsentDataStore.useStore();
    const isNextButtonDisabled =
        !signatureData.loanDocumentLoaded ||
        signatureData.applicantSignature === '' ||
        (consentData.coApplicantConsent && signatureData.coApplicantSignature === '');

    const validator = useSignatureValidator();
    const description = 'Signature must exactly match the name on the application';

    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();

    return (
        <Flex gap="8" direction="column">
            <Flex
                gap="4"
                direction="column"
                md={{ direction: 'row' }}
                className={signatureForm}
                alignSelf="center"
            >
                <TextField
                    style={{ width: '100%' }}
                    type="text"
                    label="Applicant Signature"
                    description={description}
                    onChange={event => validator.setApplicantSignature(event.target.value?.trim())}
                />
                {hasCoApplicant && (
                    <TextField
                        style={{ width: '100%' }}
                        type="text"
                        label="Co-applicant Signature"
                        description={description}
                        onChange={event =>
                            validator.setCoApplicantSignature(event.target.value?.trim())
                        }
                    />
                )}
            </Flex>
            <Flex justifyContent="space-between">
                <Stepper.PrevButton label="Back" />
                <Flex gap="3" justifyContent="flex-end" grow={1}>
                    <CancelApplicationButton>Cancel</CancelApplicationButton>
                    <>
                        <Button
                            onClick={() => {
                                setSignatureData({
                                    ...signatureData,
                                    skipSignatureButtonClicked: true,
                                });
                            }}
                        >
                            Skip Signature
                        </Button>
                        <Stepper.NextButton
                            completeLabel="Submit"
                            disabled={isNextButtonDisabled}
                            nextLabel="Next"
                        />
                    </>
                </Flex>
            </Flex>
        </Flex>
    );
};
